import Link from "../../utils/Link";
import * as React from "react";
import useTranslations from "../../../hooks/useTranslations";
import UserAvatar from "../../utils/avatars/UserAvatar";
import ActivityPlate from "../ActivityPlate";
import { Text } from "@chakra-ui/react";
import { ActivityFragment, CompanyMinimalFragment, UserMinimalFragment } from '../../../graphql/generated/definitions';

type UserCreatedActivity = ActivityFragment & {
  recipient: CompanyMinimalFragment;
  trackable: UserMinimalFragment;
};

export function isUserCreatedActivity(
  q: ActivityFragment
): q is UserCreatedActivity {
  return q.key === "user.created";
}

interface UserCreatedActivityProps {
  activity: UserCreatedActivity;
}

export const UserCreatedActivity: React.FC<UserCreatedActivityProps> = ({
  activity,
}) => {
  const t = useTranslations();
  const { trackable, id } = activity;

  return (
    <ActivityPlate
      activity={activity}
      id="userCreatedActivity"
      visual={
        <UserAvatar
          src={trackable.avatar}
          alt={`${trackable.name} avatar`}
          size={10}
        />
      }
    >
      <Text fontSize="sm">
        {t("activity.labels.collaboratorCreated", {
          collaborator: (
            <Link to={`/users/${trackable.slug}`} key={id}>
              {trackable.name}
            </Link>
          ),
        })}
      </Text>
    </ActivityPlate>
  );
};
